import { render, staticRenderFns } from "./PLPProductBoxWrapper.vue?vue&type=template&id=01ea4b1a"
import script from "./PLPProductBoxWrapper.vue?vue&type=script&lang=ts"
export * from "./PLPProductBoxWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports